<template>
    <ul class="sidenav level-1" ref="sidenav" :class="{ 'sidenav-collapsed' : sidenavIsCollapsed }">
        <li class="sidenav-heading">{{ $t('globals.my_account') }}</li>
        <li class="sidenav-item" :class="[ uriSegments[0] === 'dashboard' ? 'active' : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.dashboard') : null }">
            <a href="/dashboard">
                <span class="sidenav-icon icon icon-works">Ç</span>
                <span class="sidenav-label">{{ $t('globals.dashboard') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ uriSegments[0] === 'courses' ? 'active' : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.courses') : null }">
            <a href="/courses">
                <span class="sidenav-icon icon icon-works">&#114;</span>
                <span class="sidenav-label">{{ $t('globals.courses') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ uriSegments[0] === 'organization' && uriSegments[1] === 'details' ? 'active' : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.information') : null }">
            <a href="/organization/details">
                <span class="sidenav-icon icon icon-works">C</span>
                <span class="sidenav-label">{{ $t('globals.information') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ uriSegments[0] === 'organization' && uriSegments[1] === 'users' ? 'active' : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.users') : null }">
            <a href="/organization/users">
                <template v-if="userAdminsOrganization && pendingJoinRequests > 0">
                    <span class="sidenav-badge badge badge-primary">{{ pendingJoinRequests }}</span>
                </template>
                <span class="sidenav-icon icon icon-works">P</span>
                <span class="sidenav-label">{{ $t('globals.users') }}</span>
            </a>
        </li>
        <li v-if="userAdminsOrganization" class="sidenav-item" :class="[ uriSegments[0] === 'organization' && uriSegments[1] === 'payments' ? 'active' : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.payments') : null }">
            <a href="/organization/payments">
                <span class="sidenav-icon icon icon-works">[</span>
                <span class="sidenav-label">{{ $t('globals.payments') }}</span>
            </a>
        </li>
        <template v-if="userIsStaffMember">
            <li class="sidenav-heading">{{ $t('globals.kiosk') }}</li>
            <li v-if="userIsDeveloper || userIsMarketing" class="sidenav-item" :class="[ uriSegments[0] === 'kiosk' && uriSegments[1] === 'organizations' ? 'active' : '' ]"
                v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.organizations') : null }">
                <a href="/kiosk/organizations">
                    <span class="sidenav-icon icon icon-works">*</span>
                    <span class="sidenav-label">{{ $t('globals.organizations') }}</span>
                </a>
            </li>
            <li v-if="userIsDeveloper || userIsMarketing" class="sidenav-item" :class="[ uriSegments[0] === 'kiosk' && uriSegments[1] === 'users' ? 'active' : '' ]"
                v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.users') : null }">
                <a href="/kiosk/users">
                    <span class="sidenav-icon icon icon-works">P</span>
                    <span class="sidenav-label">{{ $t('globals.users') }}</span>
                </a>
            </li>
            <li v-if="userIsDeveloper || userIsMarketing || userIsFinancial" class="sidenav-item" :class="[ uriSegments[0] === 'kiosk' && uriSegments[1] === 'invoices' ? 'active' : '' ]"
                v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.invoices') : null }">
                <a href="/kiosk/invoices">
                    <span class="sidenav-icon icon icon-works">t</span>
                    <span class="sidenav-label">{{ $t('globals.invoices') }}</span>
                </a>
            </li>
            <li v-if="userIsDeveloper || userIsMarketing || userIsFinancial" class="sidenav-item" :class="[ uriSegments[0] === 'kiosk' && uriSegments[1] === 'communication' ? 'active' : '' ]"
                v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.communication') : null }">
                <a href="/kiosk/communication">
                    <span class="sidenav-icon icon icon-works">Ã</span>
                    <span class="sidenav-label">{{ $t('globals.communication') }}</span>
                </a>
            </li>
            <li v-if="userIsDeveloper || userIsMarketing" class="sidenav-item" :class="[ uriSegments[0] === 'kiosk' && uriSegments[1] === 'updates' ? 'active' : '' ]"
                v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.updates') : null }">
                <a href="/kiosk/updates">
                    <span class="sidenav-icon icon icon-works">J</span>
                    <span class="sidenav-label">{{ $t('globals.updates') }}</span>
                </a>
            </li>
        </template>
        <!--
        <li class="sidenav-item" :class="[  ['tasks.create'].includes(currentRoute) && ! urlParameters.includes('scheduled=true') ? ['active', 'open'] : '', ! liveSidenavIsCollapsed ? 'hidden' : '' ]"
            v-tooltip="{ content: $t('tasks.add_active_task') }">
            <a :href="`/workspace/${currentWorkspace.id}/tasks/create`">
                <span class="sidenav-icon icon icon-plus-square"></span>
                <span class="sidenav-label">{{ $t('tasks.add_active_task') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[  ['tasks.create'].includes(currentRoute) && urlParameters.includes('scheduled=true') ? ['active', 'open'] : '', ! liveSidenavIsCollapsed ? 'hidden' : '' ]"
            v-tooltip="{ content: $t('tasks.add_scheduled_task') }">
            <a :href="`/workspace/${currentWorkspace.id}/tasks/create?scheduled=true`">
                <span class="sidenav-icon icon icon-calendar-plus-o"></span>
                <span class="sidenav-label">{{ $t('tasks.add_scheduled_task') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['recurrent_tasks.create'].includes(currentRoute) ? ['active', 'open'] : '', ! liveSidenavIsCollapsed ? 'hidden' : '' ]"
            v-tooltip="{ content: $t('tasks.add_recurrent_task') }">
            <a :href="`/workspace/${currentWorkspace.id}/recurrent_tasks/create`">
                <span class="sidenav-icon icon icon-repeat"></span>
                <span class="sidenav-label">{{ $t('tasks.add_recurrent_task') }}</span>
            </a>
        </li>
        <li class="sidenav-item has-subnav bg-success m-t-lg"
            :class="[ ['tasks.create', 'recurrent_tasks.create'].includes(currentRoute) ? ['active', 'open'] : '', liveSidenavIsCollapsed ? 'hidden' : '' ]">
            <a href="javascript:;" style="color: white;">
                <span class="sidenav-icon icon icon-plus-square"></span>
                <span class="sidenav-label">{{ $t('globals.add_task') }}</span>
            </a>
            <ul class="sidenav level-2 collapse">
                <li class="sidenav-heading">{{ $t('globals.add_task') }}</li>
                <li :class="{ active : ['tasks.create'].includes(currentRoute) && ! urlParameters.includes('scheduled=true') }">
                    <a :href="`/workspace/${currentWorkspace.id}/tasks/create`">
                        {{ $t('globals.active') }}
                    </a>
                </li>
                <li :class="{ active : ['tasks.create'].includes(currentRoute) && urlParameters.includes('scheduled=true') }">
                    <a :href="`/workspace/${currentWorkspace.id}/tasks/create?scheduled=true`">
                        {{ $t('tasks.scheduled') }}
                    </a>
                </li>
                <li :class="{ active : ['recurrent_tasks.create'].includes(currentRoute) }">
                    <a :href="`/workspace/${currentWorkspace.id}/recurrent_tasks/create`">
                        {{ $t('tasks.recurrent') }}
                    </a>
                </li>
            </ul>
        </li>
        <li class="sidenav-heading">{{ $t('globals.workspace_with_name', { workspace: currentWorkspace.name }) }}</li>
        <li class="sidenav-item" :class="[ ['dashboard'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.dashboard') : null }">
            <a :href="`/workspace/${currentWorkspace.id}`">
                <span class="sidenav-icon icon icon-home"></span>
                <span class="sidenav-label">{{ $t('globals.dashboard') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['active_tasks.index', 'tasks.show', 'active_tasks.index'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.active_tasks') : null }">
            <a :href="`/workspace/${currentWorkspace.id}/active_tasks`">
            <span class="sidenav-icon icon icon-tasks"></span>
            <span class="sidenav-label">{{ $t('globals.active_tasks') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['completed_tasks.index'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.completed_tasks') : null }">
            <a :href="`/workspace/${currentWorkspace.id}/completed_tasks`">
            <span class="sidenav-icon icon icon-flag-checkered"></span>
            <span class="sidenav-label">{{ $t('globals.completed_tasks') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['scheduled_tasks.index', 'scheduled_tasks.show'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.scheduled_tasks') : null }">
            <a :href="`/workspace/${currentWorkspace.id}/scheduled_tasks`">
                <span class="sidenav-icon icon icon-calendar"></span>
                <span class="sidenav-label">{{ $t('globals.scheduled_tasks') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['recurrent_tasks.index', 'recurrent_tasks.show', 'recurrent_tasks.edit', 'recurrent_tasks.calendar'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('tasks.recurrent_tasks') : null }">
            <a :href="`/workspace/${currentWorkspace.id}/recurrent_tasks`">
                <span class="sidenav-icon icon icon-repeat"></span>
                <span class="sidenav-label">{{ $t('tasks.recurrent_tasks') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['projects.index'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.projects') : null }">
            <a :href="`/workspace/${currentWorkspace.id}/projects`">
                <span class="sidenav-icon icon icon-archive"></span>
                <span class="sidenav-label">{{ $t('globals.projects') }}</span>
            </a>
        </li>
        <li class="sidenav-item" :class="[ ['task_typologies.index'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.task_typologies') : null }">
            <a :href="`/workspace/${currentWorkspace.id}/task_typologies`">
                <span class="sidenav-icon icon icon-tags"></span>
                <span class="sidenav-label">{{ $t('globals.task_typologies') }}</span>
            </a>
        </li>
        <li class="sidenav-heading">{{ $t('globals.statistics') }}</li>
        <li class="sidenav-item" :class="[ ['statistics.index'].includes(currentRoute) ? ['active', 'open'] : '' ]"
            v-tooltip="{ content: liveSidenavIsCollapsed ? $t('globals.statistics') : null }">
            <a href="/statistics">
                <span class="sidenav-icon icon icon-bar-chart"></span>
                <span class="sidenav-label">{{ $t('globals.statistics') }}</span>
            </a>
        </li>
        -->
    </ul>
</template>

<script>
export default {
    props: {
        sidenavIsCollapsed: {
            type: Boolean,
            required: true,
        },
        pendingJoinRequests: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            hash: window.location.hash.substr(1),
            liveSidenavIsCollapsed: this.sidenavIsCollapsed,
        };
    },

    computed: {
        section() {
            const sectionParts = this.getSectionParts();

            let sectionEntity = null;
            let sectionId = null;
            let sectionAction = null;

            if (sectionParts[0]) {
                sectionEntity = sectionParts[0];
            }
            if (sectionParts[1]) {
                if (this.isNumeric(sectionParts[1])) {
                    sectionId = parseInt(sectionParts[1]);
                } else {
                    sectionAction = sectionParts[1];
                }
            }
            if (sectionParts[2] && sectionId) {
                sectionAction = sectionParts[2];
            }

            const section = {
                entity: sectionEntity,
                id: sectionId,
                action: sectionAction,
            };

            return section;
        },

        userAdminsOrganization() {
            return window.Globals.user.is_admin || window.Globals.user.organization.owner_id === window.Globals.user.id;
        },

        userIsStaffMember() {
            return window.Globals.isStaffMember;
        },

        userIsDeveloper() {
            return window.Globals.isDeveloper;
        },

        userIsMarketing() {
            return window.Globals.isMarketing;
        },

        userIsFinancial() {
            return window.Globals.isFinancial;
        },

        uriSegments() {
            return window.Globals.uriSegments;
        },
    },

    mounted() {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                const newValue = mutation.target.getAttribute('aria-expanded');
                const boolValue = newValue !== 'true';
                this.$nextTick(() => this.liveSidenavIsCollapsed = boolValue);
            }
        });

        observer.observe(this.$refs['sidenav'], { attributes: true, attributeFilter: ['aria-expanded'] });
    },

    created() {
        Bus.$on('shouldUpdateSidebarNavigationHash', ({ hash }) => this.hash = hash);
    },

    methods: {
        setHash(hash) {
            Bus.$emit('shouldUpdateHash', { hash: hash });
        },

        getSectionParts() {
            return this.hash.split('-');
        },

        isNumeric(value) {
            return ! isNaN(parseFloat(value)) && isFinite(value);
        },
    },
};
</script>
